import * as React from 'react';

interface SpinnerProps {
  visible?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({ visible = true }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="spinner">
      <div className="spinner-dot" />
      <div className="spinner-dot" />
      <div className="spinner-dot" />
    </div>
  );
};
